import { render, staticRenderFns } from "./VRCompanyContext.vue?vue&type=template&id=318be389"
import script from "./VRCompanyContext.vue?vue&type=script&lang=js"
export * from "./VRCompanyContext.vue?vue&type=script&lang=js"
import style0 from "./VRCompanyContext.vue?vue&type=style&index=0&id=318be389&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports